<template>
  <section
    id="parte-superior"
    class="linha-home"
  >
    <div
      id="noticia-destaque"
      class="secao-esquerda-home"
    >
      <h3>Destaques PREX</h3>
      <DestaquesCarousel
        v-if="destaques.length > 0"
        :destaques="destaques"
      />
    </div>

    <div
      id="vagas"
      class="secao-direita-home"
    >
      <h5 class="card-header-title">Oportunidades de Vagas</h5>
      <VagasCarousel />
      <BaseButton :to="'/vagas'"> Ver mais vagas </BaseButton>
    </div>
  </section>
</template>

<script setup>
import DestaquesCarousel from "@/components/noticias/DestaquesCarousel.vue";
import VagasCarousel from "@/components/vagas/VagasCarousel.vue";
import { useNoticias } from "@/composables/useNoticias";
import { onMounted } from "vue";
import BaseButton from "../common/BaseButton.vue";

const { destaques, fetchDestaques } = useNoticias();

onMounted(async () => {
  fetchDestaques();
});
</script>

<style scoped>
.linha-home {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.secao-esquerda-home {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.secao-direita-home {
  width: 25%;
  min-width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

@media (max-width: 768px) {
  #parte-superior {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
  }
  #noticia-destaque {
    width: 100%;
  }
  #vagas {
    width: 85%;
  }
}
</style>
